import React from 'react';

import {
  Typography as BaseTypography,
  styled
} from '@mui/material';
import { BaseSnackbar } from 'modules';



const Typography = styled(BaseTypography)(({ theme }) => ({
  color: 'white !important',
  maxWidth: 257,
  marginLeft: theme.spacing(3),
  fontSize: 16
}));

export interface IProps {
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  return (
    <BaseSnackbar.FC onClose={props.onClose}>
      <Typography>
        You have reached your download limit.
      </Typography>
    </BaseSnackbar.FC>
  );
};
